import styled from "styled-components";
import { useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { setColor } from "../../../assets/styles/styles";
import { hexToRGBA } from "../../../utils/generalUtils";
import BackgroundContainer from "../../../components/common/Backgrounds/BackgroundContainer";
import background from "../../../assets/images/backgrounds/UC_BG_Guestbook.png";

const MainContainer = ({ children }) => {
    const location = useLocation();
    const isFullWidth = location.pathname === "/console/analytics";
    return <Container isFullWidth={isFullWidth}>{children}</Container>;
};

MainContainer.propTypes = {
    children: PropTypes.node,
};

export default MainContainer;

const Container = styled(BackgroundContainer)`
    width: 100%;
    max-width: ${(props) => (props.isFullWidth ? "100vw" : "1300px")};
    height: 100%;
    background: none;
    // padding: 0 2rem 0 2rem;
    overflow-x: auto;
    overflow-y: auto;

    @media (min-width: 768px) {
        &::-webkit-scrollbar {
            display: none;
        }
    }

    @media (max-width: 768px) {
        padding: 0 2rem 5rem 2rem;
    }
`;